import { Toaster as SonnerToaster, type ToasterProps } from 'sonner';

import { useTheme } from '@/components/ThemeProvider';

/**
 * Sonner-Toaster, der dem aktuell aufgeloesten Theme folgt.
 * Sonner setzt selbst `aria-live="polite"` auf dem live-region-Container,
 * daher genuegt es, das Theme + die Tailwind-Klassen zu konfigurieren.
 */
function Toaster(props: ToasterProps): JSX.Element {
  const { resolvedTheme } = useTheme();
  return (
    <SonnerToaster
      theme={resolvedTheme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  );
}

export { Toaster };
